import { normalizeUrl } from 'fym-common/src/utils/normalizeUrl';

/** A bare host with something after it — `open.spotify.com/album/…`. */
const BARE_HOST_WITH_PATH = /^[\w-]+(\.[\w-]+)+\/\S+$/;

/**
 * Whether what the artist typed is a link rather than a search.
 *
 * One field takes both, so the sheet has to tell them apart before it decides
 * whether to resolve or to search. A scheme settles it; failing that, a host
 * with a path does, because no one searches their catalog for `x.com/y`.
 */
export function looksLikeUrl(value: string): boolean {
  const text = value.trim();
  if (text.length === 0 || /\s/.test(text)) {
    return false;
  }
  if (/^https?:\/\//i.test(text)) {
    return true;
  }
  return BARE_HOST_WITH_PATH.test(text);
}

/** The link with a scheme on it, which is the only form the inspector reads. */
export function toResolvableUrl(value: string): string {
  return normalizeUrl(value.trim());
}
